import { Leaf, Flame, Sun, HandHeart, Package, ShieldCheck } from "lucide-react";

const ITEMS = [
  {
    icon: Leaf,
    title: "100% Organic",
    body: "Grown without pesticides, on certified organic farms partnered for generations.",
  },
  {
    icon: Sun,
    title: "Sun-dried",
    body: "Slow-dried on village courtyards — no industrial dryers, no rushed heat.",
  },
  {
    icon: HandHeart,
    title: "Hand-ground",
    body: "Hand-milled in small batches so oils stay bright and aromatics stay whole.",
  },
  {
    icon: Flame,
    title: "Aromatic, always",
    body: "Packed within days of grinding. What you smell is what you'll taste.",
  },
  {
    icon: ShieldCheck,
    title: "No preservatives",
    body: "Never. Not a trace. Our shelf-life comes from the spice, not from a lab.",
  },
  {
    icon: Package,
    title: "Honest packaging",
    body: "Kraft pouches, no loud plastic — kind to the food and to the earth.",
  },
];

export const WhyUs = () => {
  return (
    <section
      id="why"
      data-testid="why-us-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.3em] text-mo-terracotta mb-4">
              — Why Maati
            </div>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-mo-ink leading-[1.05]">
              Six promises we <span className="italic text-mo-green">don't break.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-mo-ink-soft">
            Everything we do — from picking chillies to sealing pouches — is
            built to answer one question: would our mothers approve? If it
            doesn't pass her kitchen, it never makes it to yours.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ITEMS.map((it) => (
            <div
              key={it.title}
              data-testid={`why-item-${it.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative p-8 rounded-2xl bg-[#F9F6F0] border border-[#5C5248]/10 hover:border-[#B33922]/40 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="w-12 h-12 rounded-full bg-[#B33922]/10 flex items-center justify-center text-mo-terracotta mb-5 group-hover:bg-mo-terracotta group-hover:text-mo-cream transition-colors duration-500">
                <it.icon size={22} />
              </div>
              <h3 className="font-serif-display text-2xl text-mo-ink">
                {it.title}
              </h3>
              <p className="mt-3 text-sm text-mo-ink-soft leading-relaxed">
                {it.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
